import {useState } from 'react';
import Button from '@mui/material/Button';
import ApprovalDialogBox from './ApprovalDialogBox';
import DataTable from '../datatable/datatable';
import { DateTime } from 'luxon';

const RevokedUsers = ({ rows, setRows, isDataLoading, setIsDataLoading }) => {
  const [openEditConfigDialog, setOpenEditConfigDialog] = useState(false);
  const [selectedUserData, setSelectedUserData] = useState([]);

  const getFormattedDate = (raw) => {
    if (!raw) return "";
    const iso = DateTime.fromISO(raw);
    if (iso.isValid) return iso.toFormat("dd-MMM-yyyy");
    const jsDate = new Date(raw);
    if (!isNaN(jsDate.getTime())) return DateTime.fromJSDate(jsDate).toFormat("dd-MMM-yyyy");
    return String(raw);
  }

  const columns = [
    {
      header: "Action",
      width: "200px",
      cell: ({ row }) => (
        <div className='buttonContainer_signupRequest'>
           <Button variant='contained' className='button_editConfig_approveUser' color="error" onClick={() => handleEditConfiguration(row.original)}>Undo Rejection</Button>
         </div>
      )
    },
    {
      accessorKey: "name",
      header: "Name",
      width: "250px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "email",
      header: "Email",
      width: "370px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "orgName",
      header: "Organization",
      width: "250px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "countryName",
      header: "Country",
      width: "200px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "contactNo",
      header: "Contact Number",
      width: "250px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      accessorKey: "totalJdCreated",
      header: "Total JD Created",
      width: "250px",
      enableSorting: true,
      enableFiltering: true,
    },
    {
      header: "Request Date",
      width: "200px",
      enableSorting: true,
      enableFiltering: false,
      cell: ({ row }) => {
        const raw = row.original.createdAt || row.original.createdAt;
        return getFormattedDate(raw);
      }
    },
    {
      header: "Rejeceted Date",
      width: "200px",
      enableSorting: true,
      enableFiltering: false,
      cell: ({ row }) => {
        const raw = row.original.rejectedDate || row.original.rejectedDate;
        return getFormattedDate(raw); 
      }
    }
  ]

  const handleEditConfiguration = (row) => {
    setSelectedUserData(row)
    setOpenEditConfigDialog(true);
  };

  console.log("RevokedUsers rows:", rows);

  const handleRevokeUserRowChange = (data) => {
    let allPendingUsers = [...rows];
    allPendingUsers = allPendingUsers.filter((user) => user._id !== data._id);
    setRows(allPendingUsers);
    setIsDataLoading(false);
  }

  return (
    <>
       <DataTable
          data={rows}
          columns={columns}
          isLoading={isDataLoading}
          enableFiltering={true}
          enablePagination={true}
          enableSorting={false}
          pageSizeOptions={[10, 20, 50, 100]}
          noDataText="No results found !"
        />
      <ApprovalDialogBox
        open={openEditConfigDialog}
        handleClose={() => setOpenEditConfigDialog(false)}
        isEdit={true}
        isUndoRejection={true}
        userData={selectedUserData}
        setKendoDataLoading={setIsDataLoading}
        handleRevokeUserRowChange={handleRevokeUserRowChange}
      />
    </>
  );
}

export default RevokedUsers